import { useState, useEffect, useMemo } from 'react';

const STORAGE_KEY = 'offerlelo_wishlist';
const CHANGE_EVENT = 'offerlelo:wishlist-changed';

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function write(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export function getSaved() {
  return read();
}

export function isSaved(id) {
  return read().some(o => o.id === id);
}

export function toggleSave(offer) {
  const items = read();
  const idx = items.findIndex(o => o.id === offer.id);
  if (idx >= 0) items.splice(idx, 1);
  else items.unshift(offer);
  write(items);
  return idx < 0;
}

export function removeSaved(id) {
  write(read().filter(o => o.id !== id));
}

export function useWishlist() {
  const [items, setItems] = useState(read);

  useEffect(() => {
    const handler = () => setItems(read());
    window.addEventListener(CHANGE_EVENT, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(CHANGE_EVENT, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  const savedIds = useMemo(() => new Set(items.map(o => o.id)), [items]);
  return { items, savedIds, toggleSave, removeSaved };
}
